/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { Text as MantineText, type MantineTheme, createTheme } from '@mantine/core';

import { typographyToken } from '@fai/design-tokens';

import * as classes from './text.css';

export const textTheme = createTheme({
  components: {
    /** @url https://mantine.dev/core/text/ */
    Text: MantineText.extend({
      defaultProps: {
        variant: 'body-md',
      },
      styles: {
        root: {
          whiteSpace: 'pre-wrap',
        },
      },
      vars: (_, props) => {
        if (props.variant === 'title-xl') {
          return {
            root: {
              '--text-fz': typographyToken.title['typography-title-xl'].fontSize,
              '--text-lh': typographyToken.title['typography-title-xl'].lineHeight,
            },
          };
        }

        if (props.variant === 'title-lg') {
          return {
            root: {
              '--text-fz': typographyToken.title['typography-title-lg'].fontSize,
              '--text-lh': typographyToken.title['typography-title-lg'].lineHeight,
            },
          };
        }

        if (props.variant === 'title-md') {
          return {
            root: {
              '--text-fz': typographyToken.title['typography-title-md'].fontSize,
              '--text-lh': typographyToken.title['typography-title-md'].lineHeight,
            },
          };
        }

        if (props.variant === 'title-sm') {
          return {
            root: {
              '--text-fz': typographyToken.title['typography-title-sm'].fontSize,
              '--text-lh': typographyToken.title['typography-title-sm'].lineHeight,
            },
          };
        }

        if (props.variant === 'title-xs') {
          return {
            root: {
              '--text-fz': typographyToken.title['typography-title-xs'].fontSize,
              '--text-lh': typographyToken.title['typography-title-xs'].lineHeight,
            },
          };
        }

        if (props.variant === 'title-2xs') {
          return {
            root: {
              '--text-fz': typographyToken.title['typography-title-2xs'].fontSize,
              '--text-lh': typographyToken.title['typography-title-2xs'].lineHeight,
            },
          };
        }

        if (props.variant === 'body-lg') {
          return {
            root: {
              '--text-fz': typographyToken.body['typography-body-lg'].fontSize,
              '--text-lh': typographyToken.body['typography-body-lg'].lineHeight,
            },
          };
        }

        if (props.variant === 'body-md') {
          return {
            root: {
              '--text-fz': typographyToken.body['typography-body-md'].fontSize,
              '--text-lh': typographyToken.body['typography-body-md'].lineHeight,
            },
          };
        }

        if (props.variant === 'body-sm') {
          return {
            root: {
              '--text-fz': typographyToken.body['typography-body-sm'].fontSize,
              '--text-lh': typographyToken.body['typography-body-sm'].lineHeight,
            },
          };
        }

        if (props.variant === 'body-xs') {
          return {
            root: {
              '--text-fz': typographyToken.body['typography-body-xs'].fontSize,
              '--text-lh': typographyToken.body['typography-body-xs'].lineHeight,
            },
          };
        }

        return {
          root: {},
        };
      },
      classNames() {
        return {
          root: classes.root,
        };
      },
    }),
  },
}) as MantineTheme;
